import { defineComponent as _defineComponent } from 'vue'
import formatBlocksJson from '@/assets/top/top-new-format-blocks.json'

type FormatCard = {
  href: string
  id: string
  memo: string
  img_src: string
  img_alt: string
  top_class: string
  bottom_class: string
  title: string
  title_class: string
  subtitle: string
  btn_class: string
  btn_label: string
}

type FormatBlock = {
  key: string
  block_class: string
  heading: string
  heading_class: string
  lead: string
  cards: FormatCard[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopFormatBlocks',
  setup(__props) {

const blocks = (formatBlocksJson as { blocks: FormatBlock[] }).blocks

return { __sfc: true,blocks }
}

})